import { formatDistance, addYears } from 'date-fns';

export function getRelativeDate(unixTimeSecs: number): string {
  const date = new Date(unixTimeSecs * 1000);
  const now = new Date();
  // if date is more than 1 year ago from now, then show mm/yyyy
  if (addYears(date, 1) < now) {
    return date.toLocaleDateString('en-US', {
      month: 'numeric',
      year: 'numeric',
    });
  }
  return formatDistance(date, new Date(), {
    includeSeconds: false,
    addSuffix: true,
  });
}
